export enum CookieBannerType {
  RBI_COOKIE_BANNER = 'customCookieBanner',
  COOKIEBOT_COOKIE_BANNER = 'cookieBotCookieBanner',
  ONE_TRUST_COOKIE_BANNER = 'oneTrust',
}
